<script setup lang="ts">
import SpinLoader from '@/components/SpinLoader.vue';
</script>
<template>
  <SpinLoader />
</template>
